import React from 'react'
import UnowLoader from '../../UnowLoader'

import styles from './styles.module.scss'

const Loader = () => (
  <div className={styles.loader}>
    <UnowLoader size={32} />
  </div>
)

export default Loader
